//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/CAM.js";
import "../CAM/CAM.Boundary.js";
let d=[[[0,"InitialToolPosition",1,0]],[[["face","ignoreHole","ignoreIsland","ignoreChamfer","toolSide","convexEdges","concaveEdges","count"],"AppendPlanarMillFaceBoundary",{R_:{bndSets:"CAM.BoundarySet[]"}},7,0]],[]];
SPLM.CAM.BoundaryPlanarMill = class extends SPLM.CAM.Boundary{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.CAM.BoundaryPlanarMill";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.CAM.BoundaryPlanarMill.ToolPositionTypes = Object.freeze({
    "On" : "On", "TangentTo" : "TangentTo"});

export default SPLM;